import {EditorState, type Extension, Annotation} from '@codemirror/state'

// Annotation to mark external updates that should bypass readonly protection
export const externalUpdate = Annotation.define<boolean>()

export function readOnly(): Extension {
  return [
    EditorState.readOnly.of(true),
    EditorState.transactionFilter.of(tr => {
      // Allow transactions marked as external updates, block all other document changes
      if (tr.docChanged && !tr.annotation(externalUpdate)) {
        return []
      }
      return tr
    }),
  ]
}
